

/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-16 10:51:57
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2023-02-02 14:59:53
 * @FilePath: /unified-development-platform/src/store/getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const getters = {
  appBaseURL: state => state.appBase.appBaseURL,
  appRootPath: state => state.appBase.appRootPath,
  isAppPreview: state => state.appBase.isAppPreview,
  appId: state => state.app.appId,
  userInfo: state => state.appBase.userInfo,
  memInfo: state => state.memInfo,
  userInfo: state => state.userInfo
}
export default getters
